import { render, staticRenderFns } from "./SelectDriverAndTruck.vue?vue&type=template&id=222190b4"
import script from "./SelectDriverAndTruck.vue?vue&type=script&lang=js"
export * from "./SelectDriverAndTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports